import React, { ReactNode } from 'react';
import Link from '../../lib/router/Link';
import router from '../../lib/router/router';

function getMainRoutePath(query?: string): string {
  return query ? `/q/${encodeURIComponent(query)}` : '/';
}

function navigateToMainPage(query?: string) {
  router.pushState(getMainRoutePath(query));
}

interface IIndexLinkProps {
  query?: string;
  onClick?: Function;
  className?: string;
  dataHook?: string;
  children: string | ReactNode;
}

function IndexLink({
  query,
  onClick,
  children,
  className,
  dataHook,
}: IIndexLinkProps) {
  return (
    <Link
      onClick={onClick}
      className={className}
      dataHook={dataHook}
      href={getMainRoutePath(query)}
    >
      {children}
    </Link>
  );
}

export { getMainRoutePath, navigateToMainPage };

export default IndexLink;
